import type { Metric } from "web-vitals";
import { onCLS, onFID, onLCP, onTTFB, onINP } from "web-vitals";
import { adminSdk } from "@shared/lib/http";

function isSampled() {
  return Math.random() < 0.1;
}

async function send(metric: Metric) {
  try {
    // Use the shared admin SDK client so the configured API base URL and auth headers are applied
    await adminSdk.metrics.vitals({
      name: metric.name,
      value: metric.value,
      id: metric.id,
      path: window.location.pathname,
    });
  } catch {}
}

export function initVitals() {
  if (!isSampled()) return;
  onCLS(send);
  onFID(send);
  onLCP(send);
  onTTFB(send);
  onINP?.(send as any);
}
